<template>
  <div class="open-app" v-show="show">
    <div class="close" @click="show = !show">
      <img src="@/assets/student/closeX.png" alt="" />
    </div>
    <div class="logo">
      <img src="@/assets/usercenter/parentHandbook/logo.png" alt="" />
    </div>
    <div class="desc">{{ $t("src_components_openApp_index_e86a4c6a") }}</div>
    <div class="open" @click="openApp('h5', path)">
      <span>{{ $t("src_components_openApp_index_f3dda5c6") }}</span>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { openApp } from "@/utils/openApp";

export default Vue.extend({
  data() {
    return {
      show: true
    };
  },

  computed: {
    path() {
      let url = this.$route.query.openapp;

      if (url === "cpage") {
        url = location.href;
      }
      return url;
    }
  },

  methods: {
    openApp(type: string, url: string) {
      openApp({ type, url });
    }
  },

  mounted() {
    this.openApp("h5", this.path as string);
  }
});
</script>
<style lang="scss" scoped>
.open-app {
  width: 750px;
  height: 128px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 100%;
    height: 100%;
  }
  .close {
    width: 36px;
    height: 36px;
    margin-left: 28px;
  }
  .logo {
    width: 88px;
    height: 88px;
  }
  .desc {
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
  }
  .open {
    width: 244px;
    height: 100%;
    background-color: #ff3300;

    font-size: 28px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
